import React from 'react'

import { CruiseContentSections, CRUISE_CONTENT_SECTION_LABELS } from 'constants/cruise'
import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import CruiseShipOverview from './CruiseShipOverview'
import CruiseDecksAndCabins from '../DecksAndCabins/CruiseDecksAndCabins'
import CruiseShipAmenities from './CruiseShipAmenities/CruiseShipAmenities'

interface Props {
  offer: App.CruiseOffer
  contentSections: Set<CruiseContentSections>
  reachedTabsSection: boolean
  scrollToPackageOptions: (id: string) => void
}

function CruiseShip({
  offer,
  contentSections,
  reachedTabsSection,
  scrollToPackageOptions,
}: Props) {
  return <LayoutContainer>
    <Pane padding="32 0">
      <Group direction="vertical" gap={56}>
        <Group direction="vertical" gap={48}>
          <Heading
            align="center"
            variant="heading2"
            className="section-title"
          >About the ship
          </Heading>
          <div className="section-content">
            <CruiseShipOverview offer={offer} />
          </div>
        </Group>

        <CruiseShipAmenities ship={offer.ship} />

        {contentSections.has(CruiseContentSections.DECKS_AND_CABINS) && (
          <Group direction="vertical" gap={48}>
            <Heading
              align="center"
              variant="heading2"
              className="section-title"
            >{CRUISE_CONTENT_SECTION_LABELS[CruiseContentSections.DECKS_AND_CABINS]}
            </Heading>

            <div className="section-content">
              <CruiseDecksAndCabins
                ship={offer.ship}
                hasGotToOverview={reachedTabsSection}
                showPackageOptions={() => scrollToPackageOptions('dates-and-pricing')}
              />
            </div>
          </Group>
        )}
      </Group>
    </Pane>
  </LayoutContainer>
}

export default CruiseShip
